import { z } from 'zod';

export const TradeReviewMetricsResponseSchema = z.object({
  year: z.object({
    totalReviewCount: z.number(),
    tidiness: z.object({
      scoreAverage: z.number(),
    }),
    qualityOfWorkmanship: z.object({
      scoreAverage: z.number(),
    }),
    reliabilityAndTimekeeping: z
      .object({
        scoreAverage: z.number(),
      })
      .optional(),
    courtesy: z
      .object({
        scoreAverage: z.number(),
      })
      .optional(),
    communication: z.object({
      scoreAverage: z.number(),
    }),
    score: z.number(),
  }),
});

export const TradeMetricsSchema = z.object({
  totalScore: z.number(),
  recentReviewCount: z.number(),
  workmanship: z.number(),
  reliability: z.number().optional(),
  courtesy: z.number().optional(),
  communication: z.number().optional(),
});

export type TradeMetrics = z.infer<typeof TradeMetricsSchema>;
